/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Show_WordsInputs */



/**
* | output |
* | --- |
* | "Show Total Words" |
*
* @param {Options_Metrics_Show_WordsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_show_words = /** @type {((inputs?: Options_Metrics_Show_WordsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Show_WordsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Show Total Words")
	if (locale === "de") return /** @type {LocalizedString} */ ("Show Total Words")
	if (locale === "it") return /** @type {LocalizedString} */ ("Show Total Words")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Show Total Words")
	if (locale === "es") return /** @type {LocalizedString} */ ("Show Total Words")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Show Total Words")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Show Total Words")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Show Total Words")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Show Total Words")
	return /** @type {LocalizedString} */ ("Show Total Words")
});